var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3505_1134)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 10.0001C16.4211 10.5572 16.669 11.2497 16.669 12.0001C16.669 12.7505 16.4211 13.4429 16.0026 14.0001M8.4026 10.0001H9.0034C9.37069 10.0001 9.55433 10.0001 9.72451 9.95427C9.87529 9.91371 10.0178 9.84697 10.1455 9.75711C10.2896 9.65568 10.4071 9.51461 10.6423 9.23245L12.3929 7.13172C12.6833 6.78317 12.8286 6.6089 12.9554 6.59076C13.0653 6.57506 13.1758 6.61505 13.2501 6.69744C13.3359 6.79259 13.3359 7.01944 13.3359 7.47315V16.527C13.3359 16.9807 13.3359 17.2075 13.2501 17.3027C13.1758 17.3851 13.0653 17.4251 12.9554 17.4094C12.8286 17.3912 12.6833 17.2169 12.3929 16.8684L10.6423 14.7677C10.4071 14.4855 10.2896 14.3444 10.1455 14.243C10.0178 14.1531 9.87529 14.0864 9.72451 14.0458C9.55433 14.0001 9.37069 14.0001 9.0034 14.0001H8.4026C8.02924 14.0001 7.84255 14.0001 7.69994 13.9274C7.5745 13.8635 7.47252 13.7615 7.4086 13.6361C7.33594 13.4934 7.33594 13.3068 7.33594 12.9334V11.0667C7.33594 10.6934 7.33594 10.5067 7.4086 10.3641C7.47252 10.2386 7.5745 10.1366 7.69994 10.0727C7.84255 10.0001 8.02924 10.0001 8.4026 10.0001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3505_1134",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13D5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A687D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/soundOn.c77aaedb8a7bfb28a3ed89a5896be721.svg";
export { ForwardRef as ReactComponent };